import { Link } from "react-router-dom";
import { useSite } from "@/components/site/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { IconWifi, IconBolt } from "@/components/site/icons";

export default function Home() {
  const c = useSite();
  useSeo("Telecomunicazioni & Impianti Tecnologici", "POWERCOM realizza infrastrutture in fibra ottica e rame e impianti tecnologici per aziende, enti e privati: progettazione, realizzazione e manutenzione.");
  return (
    <>
      <section className="hero" data-testid="home-hero">
        <div className="hero-bg" />
        <div className="container hero-content reveal">
          <span className="eyebrow light">{c.hero_eyebrow}</span>
          <h1>{c.hero_title}</h1>
          <p className="lead">{c.hero_subtitle}</p>
          <div className="hero-actions">
            <Link to="/servizi" className="btn btn-light" data-testid="hero-services-btn">Scopri i servizi</Link>
            <Link to="/contatti" className="btn btn-ghost" data-testid="hero-contact-btn">Contattaci</Link>
          </div>
          <div className="hero-stats">
            <div><strong>Telco</strong><span>Reti Fisse in Fibra Ottica e Rame</span></div>
            <div><strong>Impianti</strong><span>Elettrici e tecnologici</span></div>
            <div><strong>24/7</strong><span>Manutenzione dedicata</span></div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container split">
          <div className="split-text reveal">
            <span className="eyebrow">Chi Siamo</span>
            <h2>{c.about_title}</h2>
            <p>{c.about_p1}</p>
            <Link to="/chi-siamo" className="link-arrow">Scopri di più su di noi →</Link>
          </div>
          <div className="split-img reveal">
            <img src="https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Tecnico POWERCOM" />
          </div>
        </div>
      </section>

      <section className="section section-soft">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">I Nostri Servizi</span>
            <h2>{c.services_intro_title}</h2>
            <p>{c.services_intro_text}</p>
          </div>
          <div className="cards cols-2">
            <article className="card reveal">
              <div className="ico"><IconWifi /></div>
              <h3>Telecomunicazioni</h3>
              <p>Infrastrutturazione, delivery & assurance delle reti in fibra ottica e manutenzione della rete rame, con assistenza continuativa dedicata.</p>
            </article>
            <article className="card reveal">
              <div className="ico"><IconBolt /></div>
              <h3>Impianti Tecnologici</h3>
              <p>Impianti elettrici, videosorveglianza, allarmi, antincendio, idrico-sanitari e climatizzazione, con manutenzione e assistenza programmata.</p>
            </article>
          </div>
          <div className="center reveal"><Link to="/servizi" className="btn">Vedi tutti i servizi</Link></div>
        </div>
      </section>

      <section className="cta">
        <div className="container cta-inner reveal">
          <h2>Hai un progetto da realizzare?</h2>
          <p>Contatta POWERCOM per una consulenza tecnica gratuita e senza impegno.</p>
          <Link to="/contatti" className="btn btn-light">Richiedi informazioni</Link>
        </div>
      </section>
    </>
  );
}
